exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#sidebar{transition:all .3s ease-in-out;z-index:9}#sidebar span{opacity:0;position:absolute;transition:all .1s ease-in-out}#sidebar:hover{width:150px;box-shadow:0 25px 50px -12px rgba(0,0,0,.25)}#sidebar:hover span{opacity:1}", ""]);

// exports
